import type { ColorDeBadge } from '@/shared/components/Badge'

/**
 * Color del Badge para cada estatus de candidato, según el mapeo semántico de
 * la plataforma (aprobado/contratado en verde, en proceso en azul, en espera en
 * amarillo, descartado en rojo).
 */
const COLOR_POR_ESTATUS: Record<string, ColorDeBadge> = {
  pre_registro: 'azul',
  registrado: 'azul',
  pendiente: 'amarillo',
  en_proceso: 'azul',
  entrevista_rh: 'azul',
  entrevista_solicitante: 'azul',
  pre_seleccionado: 'azul',
  pendiente_cierre: 'amarillo',
  pendiente_direccion: 'amarillo',
  decision_direccion: 'azul',
  seleccionado: 'verde',
  contratado: 'verde',
  rechazado: 'rojo',
  rechazado_evaluacion_rh: 'rojo',
}

export const colorDeEstatusDeCandidato = (
  status?: string | null,
  porDefecto: ColorDeBadge = 'gris',
): ColorDeBadge => (status && COLOR_POR_ESTATUS[status]) || porDefecto
